var _metadata, _defs, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiffPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    id: "svg12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata14"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs16"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#F2F2F2",
    id: "circle2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 37.1668,13.9175 H 18.8335 c -1.5188,0 -2.75,1.2312 -2.75,2.75 v 14.6666 c 0,1.5188 1.2312,2.75 2.75,2.75 h 18.3333 c 1.5188,0 2.75,-1.2312 2.75,-2.75 V 16.6675 c 0,-1.5188 -1.2312,-2.75 -2.75,-2.75 z",
    id: "path4",
    style: {
      stroke: "#b3b3b3",
      strokeWidth: 1.5,
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.5833,21.2499 c 1.0126,0 1.8334,-0.8208 1.8334,-1.8333 0,-1.0125 -0.8208,-1.8333 -1.8334,-1.8333 -1.0125,0 -1.8333,0.8208 -1.8333,1.8333 0,1.0125 0.8208,1.8333 1.8333,1.8333 z",
    strokeMiterlimit: 10,
    id: "path6",
    style: {
      stroke: "#b3b3b3",
      strokeWidth: 1.5,
      strokeMiterlimit: 10,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 30.7502,28.5705 -5.1941,-5.1843 c -0.3305,-0.3304 -0.7748,-0.5222 -1.2419,-0.536 -0.4672,-0.0139 -0.922,0.1512 -1.2715,0.4615 l -6.9592,6.1875",
    id: "path8",
    style: {
      stroke: "#b3b3b3",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26.1667,34.0836 7.0664,-7.0663 c 0.3232,-0.3238 0.7557,-0.5151 1.2127,-0.5363 0.457,-0.0212 0.9054,0.1292 1.2571,0.4217 l 4.2138,3.5143",
    id: "path10",
    style: {
      stroke: "#b3b3b3",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 31.377075,
    x: 13.33894,
    height: 13.245849,
    width: 29.322121,
    id: "rect820",
    style: {
      fill: "#b3b3b3",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.91028678,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "text849",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.33986741
    },
    transform: "scale(1.0816435,0.92451903)",
    "aria-label": "TIFF"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path820",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.33986741
    },
    d: "m 16.30871,38.977139 v -1.064852 h 5.192795 v 1.064852 h -1.950037 v 5.315494 h -1.314632 v -5.315494 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path822",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.33986741
    },
    d: "m 24.151705,37.912287 v 6.380346 h -1.314632 v -6.380346 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path824",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.33986741
    },
    d: "m 25.881664,44.292633 v -6.380346 h 4.158618 v 1.064852 h -2.839605 v 1.647672 h 2.524093 v 1.060469 h -2.524093 v 2.607353 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path826",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.33986741
    },
    d: "m 31.305736,44.292633 v -6.380346 h 4.158618 v 1.064852 H 32.62475 v 1.647672 h 2.524092 V 41.68528 H 32.62475 v 2.607353 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiffPreview);
export default __webpack_public_path__ + "static/media/tiff-preview.b7fb28d7.svg";
export { ForwardRef as ReactComponent };